// ===============  HANDLE HEADER ICON INDICATORS ================

const headerIconCounters = () => document.querySelectorAll('.gdc-header-icon-counter')
const showIndicator = (i) => i.classList.remove('gdc-hide-icon-indicator')
const hideIndicator = (i) => i.classList.add('gdc-hide-icon-indicator')
const contentHasValue = (elem) => parseInt(elem.innerHTML) > 0

function handleIndicator() {
  headerIconCounters().forEach((indicator) => {
    contentHasValue(indicator) ? showIndicator(indicator) : hideIndicator(indicator)
  })
}

function handleHeaderIconCounters() {
  handleIndicator()

  headerIconCounters().forEach((indicator) => {
    const observer = new MutationObserver(handleIndicator)
    observer.observe(indicator, { childList: true })
  })
}

window.addEventListener('DOMContentLoaded', handleHeaderIconCounters)

// ===============  MEGA NAV  ================

function closeMegaNavs() {
  const megaNavTriggers = document.querySelectorAll('.gdc-js-mega-menu-item')
  megaNavTriggers.forEach((trigger) => {
    trigger.classList.remove('focus')
  })
}

function handleMegaNavResizeClose() {
  window.innerWidth <= 1024 && closeMegaNavs()
}

function handlePromoImages() {
  const images = document.querySelectorAll('.gdc-mega-menu .menu-promotion-background-image figure')

  images.forEach((img) => (img.style.paddingTop = '105%'))
}

window.addEventListener('DOMContentLoaded', handlePromoImages)
window.addEventListener('scroll', closeMegaNavs)
window.addEventListener('resize', handleMegaNavResizeClose)

// ========================================================

function atPageBottom(offset = 100) {
  let documentHeight = document.body.scrollHeight
  let currentScroll = window.scrollY + window.innerHeight
  // When the user is [offset]px from the bottom, fire the event.

  return currentScroll + offset > documentHeight
}

// =============== STICKY NAV =================================

const announcementBar = () => document.querySelector('.gdc-announcement-bar')
const siteNav = () => document.querySelector('#site-header')

const totalAdjust = announcementBar().offsetHeight + siteNav().offsetHeight

const fixElem = () => {
  siteNav().classList.add('gdc-fixed')
  siteNav().style.top = 0
}

function addPageMargin() {
  const page = document.querySelector('main')

  page.style.marginTop = `${siteNav().offsetHeight}px`
  if (window.innerWidth < 399) {
    page.style.marginTop = `${totalAdjust}px`
  }
}

const unFixElem = () => {
  siteNav().classList.remove('gdc-fixed')

  if (announcementBar()) {
    siteNav().style.top = `${announcementBar().offsetHeight}px`
  } else {
    siteNav().style.top = 0
  }
}

function elementAtPageTop() {
  const offsetHeight = announcementBar() ? announcementBar().offsetHeight : 0

  return window.scrollY <= offsetHeight
}

function handleStickyNav(e) {
  if (e.type == 'DOMContentLoaded') addPageMargin()
  elementAtPageTop() ? unFixElem() : fixElem()
}

if (window.innerWidth > 400) {
  window.addEventListener('DOMContentLoaded', handleStickyNav)
  window.addEventListener('scroll', handleStickyNav)
  window.addEventListener('resize', handleStickyNav)
} else {
  window.addEventListener('DOMContentLoaded', handleStickyNav)
  window.addEventListener('resize', handleStickyNav)
}

// ========== EXTERNAL LINKS OPEN IN NEW TAB ===============

function setAllExternalLinksToOpenInNewTab() {
  const links = document.querySelectorAll("a[href^='https://'], a[href^='http://']")
  const host = window.location.hostname

  const isInternalLink = (elem) => new URL(elem).hostname === host

  links.forEach((link) => {
    if (!isInternalLink(link)) {
      link.setAttribute('target', '_blank')
      link.setAttribute('rel', 'noopener')
    }
  })
}

window.addEventListener('DOMContentLoaded', setAllExternalLinksToOpenInNewTab)

// ============= HANDLE PEEKABOO FOOTER MARGIN ===============

// set bottom margin based on footer height for peekaboo footer
function handleMainSectionMargin() {
  const main = document.querySelector('main.main-content')
  const footer = document.querySelector('.main-footer')

  if (window.innerWidth > 949) {
    if (footer && main) {
      main.style.marginBottom = `${footer.offsetHeight}px`
    }
  } else {
    main.style.marginBottom = `0px`
  }
}

window.addEventListener('load', handleMainSectionMargin)
window.addEventListener('resize', handleMainSectionMargin)
